var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    fill: "none",
    viewBox: "0 0 14 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#090707",
    d: "M10.1603 0.969728L9.53673 1.56501L12.3118 4.21393L-5.87492e-07 4.21393L-7.39946e-07 5.05579L12.3118 5.0558L9.53673 7.70468L10.1603 8.29997L14 4.63483L10.1603 0.969728Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingFlat);
export default __webpack_public_path__ + "static/media/trending-flat.41da1a2f3db57e5a1565023f205aa84f.svg";
export { ForwardRef as ReactComponent };